import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/blocks/data-table/data-table.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/blocks/data-table/utils/create-data-table-column-helper.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/alert/alert.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/avatar/avatar.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/calendar/_internal-calendar.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/calendar/calendar.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/checkbox/checkbox.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/code-block/code-block.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/command-bar/command-bar.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/command/command.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/copy/copy.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/currency-input/currency-input.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/date-picker/date-picker.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/drawer/drawer.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/dropdown-menu/dropdown-menu.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/focus-modal/focus-modal.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/i18n-provider/i18n-provider.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/input/input.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/label/label.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/progress-accordion/progress-accordion.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/progress-tabs/progress-tabs.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/prompt/prompt.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/radio-group/radio-group.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/select/select.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/switch/switch.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/tabs/tabs.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/toaster/toaster.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/components/tooltip/tooltip.js");
;
import(/* webpackMode: "eager", webpackExports: ["usePrompt"] */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/hooks/use-prompt/use-prompt.js");
;
import(/* webpackMode: "eager", webpackExports: ["useToggleState"] */ "/app/apps/web/node_modules/@medusajs/ui/dist/esm/hooks/use-toggle-state/use-toggle-state.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-context-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-hover-card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-label/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-menubar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-radio-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-toggle-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-toggle/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-toolbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/radix-ui/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/modules/common/components/localized-client-link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/modules/products/components/product-actions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/modules/products/components/product-tabs/index.tsx");
